module.exports = __webpack_public_path__ + "media/stigler.e47a929a.mp4";